// Ported from eb-ui `src/legacy/PageLayout/PageLayout.tsx` — the site chrome
// wrapper. In the new app the CHROME is already `BspPageShell` (rendered in
// `app.tsx`), so `PageLayout` is a THIN wrapper:
//   - `preview` → the `PageLayoutPreview` (device toggle + AutocreatedPill),
//   - else → pass `children` straight through.
// It no longer takes env/request/user/footerLinks/featureFlags (the legacy
// SiteStructure / AuthenticatedHeader / RenderGlobalNavOrUndefined are
// replaced by the app-shell chrome).
import React, { ReactNode } from 'react';

import { PageLayoutPreview } from './';

interface Props {
    children?: ReactNode;
    preview?: boolean;
}

export const PageLayout: React.FC<Props> = ({ children, preview }) => {
    if (preview) {
        return <PageLayoutPreview>{children}</PageLayoutPreview>;
    }

    return <>{children}</>;
};
